// extracted by mini-css-extract-plugin
module.exports = {"disable":"Button_disable__1DLDd","btnIcon":"Button_btnIcon__1IMLW"};